import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from 'core-client/api';

export const authGuard = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Check if user is authenticated
  const isAuthenticated = authService.isAuthenticated();

  if (!isAuthenticated) {
    // For OAuth users, check if they have a valid token that might not be reflected in the auth state yet
    const externProvider = sessionStorage.getItem('extern_provider');
    if (externProvider) {
      // Give the OAuth service a moment to initialize
      return new Promise<boolean>((resolve) => {
        // Wait for authentication state to be determined
        const subscription = authService.isAuthenticated$().subscribe(authState => {
          if (authState) {
            subscription.unsubscribe();
            resolve(true);
          } else {
            // Wait a bit longer for OAuth initialization
            setTimeout(() => {
              const finalAuthState = authService.isAuthenticated();
              if (!finalAuthState) {
                router.navigate(['']);
              }
              subscription.unsubscribe();
              resolve(finalAuthState);
            }, 1000);
          }
        });
      });
    } else {
      // No OAuth provider, redirect to login
      router.navigate(['']);
      return false;
    }
  }

  return isAuthenticated;
}
